module.exports = "/img/partnership-2.c7695969.png";